import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-initialized-attach-modal',
  templateUrl: './initialized-attach-modal.component.html',
  styleUrls: ['./initialized-attach-modal.component.css']
})
export class InitializedAttachModalComponent {

  @Input() pageData: any;
  alert: any;

  constructor(public activeModal: NgbActiveModal) {
  }

  confirmClicked() {
    this.activeModal.close();
  }

  cancelClicked() {
    this.activeModal.dismiss();
  }
}
